import React from 'react';
import checked from './Assets/checked.svg';
import rocket from './Assets/rocket.svg';
import { SuccessInfoStyle } from './Style';
import { useTranslation } from 'react-i18next';
import { smallCloseIcon } from '../../../../Assets/images/Icons';
import wave from './Assets/wave.svg';

type SuccessInfoProps = {
  onClose: () => void;
  onResendEmail: () => void;
  newUserId: number | null;
};

const SuccessInfo: React.FunctionComponent<SuccessInfoProps> = ({
  onClose,
  newUserId,
  onResendEmail,
}): React.ReactElement => {
  const { t } = useTranslation();

  const style: React.CSSProperties = {
    background: `Url(${wave})`,
    backgroundPosition: 'left bottom',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
  };

  return (
    <SuccessInfoStyle style={style}>
      <div className="closeIcon" onClick={onClose}>
        {smallCloseIcon}
      </div>
      <img alt="checked" src={checked} />
      <p>
        <span className="bold">{t('Thank you for registration.')}</span> <br />
        {t('Check your email and activate your account.')}
      </p>
      <img alt="rocket" src={rocket} />

      {!!newUserId && (
        <div className="bottomText">
          <span>{t('Email not received?')}&nbsp;</span>
          <span className="clickable" onClick={onResendEmail}>
            {t('Send it again.')}
          </span>
        </div>
      )}
    </SuccessInfoStyle>
  );
};

export default SuccessInfo;
